import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import i18n from './i18n';
import { fetchTranslations } from './services/api';
import fallbackFr from './locales/fr.json';
import fallbackEn from './locales/en.json';
import { deepMerge } from './utils/deepMerge';

const root = ReactDOM.createRoot(document.getElementById('root'));

const bootstrap = async () => {
  let translations = { fr: fallbackFr, en: fallbackEn };

  try {
    const remoteTranslations = await fetchTranslations();
    if (remoteTranslations && Object.keys(remoteTranslations).length > 0) {
      translations = {
        fr: deepMerge(fallbackFr, remoteTranslations.fr),
        en: deepMerge(fallbackEn, remoteTranslations.en)
      };
    }
  } catch (error) {
    console.warn('Impossible de récupérer les traductions distantes, utilisation du fallback.', error);
  } finally {
    Object.entries(translations).forEach(([lang, content]) => {
      if (!i18n.hasResourceBundle(lang, 'translation')) {
        i18n.addResourceBundle(lang, 'translation', content);
      } else {
        i18n.addResourceBundle(lang, 'translation', content, true, true);
      }
    });

    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }
};

bootstrap();

reportWebVitals();
